//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { isProductType } from '@motionelements/core/src/services/catalog.service.js';
import * as foldersAPI from '@motionelements/core/src/api/folders.js';

export default {
  name: 'LandingDlpLightboxElements',
  components: {
    ProductCard: () => import('@motionelements/core/src/components/product-card/ProductCard.vue'),
    ProductCardAudioBackground: () => import('@motionelements/core/src/components/product-card/sections/ProductCardBackgroundAudio.vue'),
    ProductCardAudio: () => import('@motionelements/core/src/components/product-card/ProductCardAudio.vue'),
    Pagination: () => import('@motionelements/core/src/components/ui/BasePagination.vue'),
    ElementsPreloader: () => import('@motionelements/core/src/components/product/ElementsPreloader.vue'),
  },
  props: {
    lightbox: { type: Object, required: true },
  },
  data() {
    return {
      elements: [],
      loading: false,
      pagination: {
        page: 1,
        perPage: 12, // show 12 items, which can fit all displays
        totalCount: 0,
      },
    };
  },
  computed: {
    ...mapGetters({
      ssrLightboxElements: 'dlp/ssrLightboxElements',
    }),
    artistPicksAudio() {
      return this.elements.filter(x => isProductType('audio', x.mediaType));
    },
    artistPicksNotAudio() {
      return this.elements.filter(x => !isProductType('audio', x.mediaType));
    },
  },
  created() {
    // Use SSR pre-fetched data for the first lightbox (page 1 only) to support SEO
    const ssrData = this.ssrLightboxElements && this.ssrLightboxElements[this.lightbox.id];
    if (ssrData && ssrData.elements && ssrData.elements.length) {
      this.elements = ssrData.elements;
      this.pagination.totalCount = ssrData.totalCount || 0;
    } else {
      this.getLightboxItems();
    }
  },
  methods: {
    onChangePage(page) {
      this.pagination.page = page;
      this.getLightboxItems();
    },
    getLightboxItems() {
      this.loading = true;
      foldersAPI.listFolderItems(this.lightbox.id, {
        page: this.pagination.page,
        per_page: this.pagination.perPage,
        published: true,
      })
        .then(({ data: { data: elements, totalCount } }) => {
          this.elements = elements || [];
          this.pagination.totalCount = totalCount || 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
